<div class="header {{ headerTheme() }}">
  <div class="left-side">
    @if (firebaseUser() && firebaseUser()?.emailVerified) {
      <button mat-icon-button aria-label="Open menu" (click)="openHeaderNav()">
        <span class="material-symbols-outlined" aria-hidden="true">menu</span>
      </button>
    }

    <div class="logo">
      <a routerLink="/dashboard">
        <img src="assets/images/logos/jfw_logo{{ headerLogo() }}.png" />
      </a>
    </div>

    <div class="jfw-title">
      <span>
        @if (newSite()) {
          Dealer Portal
        } @else {
          Referral Dashboard
        }
      </span>
    </div>
  </div>

  <div class="middle"></div>

  <div class="right-side">
    <!-- will re-enable search button when event search is enabled -->
    <!-- <button mat-icon-button title="Search" (click)="openSearchNav()">
      <span class="material-symbols-outlined">search</span>
    </button> -->

    <div class="account">
      @if (firebaseUser() && firebaseUser()?.emailVerified) {
        @if (enableFeedback()) {
          <button
            mat-icon-button
            type="button"
            class="feedback-button"
            aria-label="Send feedback"
            title="Send feedback"
            (click)="openFeedback.emit()"
          >
            <mat-icon>campaign</mat-icon>
          </button>
        }
        <button
          mat-icon-button
          routerLink="/setup/account-info"
          aria-label="Account settings"
          title="Account settings"
        >
          <mat-icon>account_circle</mat-icon>
        </button>

        @if (displayName()) {
          <div class="display-name">
            <span class="dealer-user-name">{{ displayName() }}</span
            ><br />

            @if (currentDealer(); as currentDealer) {
              @if (userDealers(); as userDealers) {
                @if (userDealers.length > 1) {
                  @if (dealerIdForm(); as dealerIdForm) {
                    <form [formGroup]="dealerIdForm">
                      <mat-select
                        [formControl]="dealerIdForm.controls.dealerId"
                        (selectionChange)="
                          newDefaultDealerId.emit($event.value)
                        "
                      >
                        @for (dealer of userDealers; track dealer.dealerId) {
                          <mat-option [value]="dealer.dealerId">
                            {{ dealer.dealerId }}
                          </mat-option>
                        }
                      </mat-select>
                    </form>
                  }
                } @else {
                  <span class="dealer-id">{{ currentDealer.dealerId }}</span>
                }
              }
            }
          </div>
        }
      }
    </div>
  </div>

  @switch (servedEnvironment()) {
    @case ("local") {
      <div class="local-site">Local</div>
    }
    @case ("dev") {
      <div class="dev-site">Dev</div>
    }
    @case ("test") {
      <div class="test-site">Test</div>
    }
  }
</div>
